__turbopack_context__.v({
  "clip": "lJRxmW_clip",
  "clipRemainder": "lJRxmW_clipRemainder",
  "empty": "lJRxmW_empty",
  "filled": "lJRxmW_filled",
  "partial": "lJRxmW_partial",
  "row": "lJRxmW_row",
  "star": "lJRxmW_star",
});
